import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-anlegen2';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentAnlegen2Effects {

    IncidentAnlegen2$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_ANLEGEN2),
        mergeMap((x: ac.PostIncidentAnlegen2Action) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentAnlegen2(x.incidentAnlegen2Request).pipe(
                map((result: any) => {
                    return new ac.PostIncidentAnlegen2ErfolgreichAction(result, x.incidentAnlegen2Request, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentAnlegen2FehlerAction(error, x.incidentAnlegen2Request, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
